function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Br\xEDet",
  transform: "translate(-181.000000, -1905.000000)"
}, React.createElement("g", {
  id: "Group-11",
  transform: "translate(181.000000, 1905.000000)"
}, React.createElement("path", {
  d: "M545.761814,199.241919 C553.720698,288.294585 360.704218,346.380591 194.570459,305.843768 C28.4366997,265.306944 -47.7775918,107.006076 31.4986682,22.6571512 C110.774928,-61.691774 537.80293,110.189253 545.761814,199.241919 Z",
  id: "Background-Shape",
  fill: "#FBFBFB"
}), React.createElement("path", {
  d: "M282.16666,256.978093 C289.296164,181.45207 671.824404,35.6788901 742.839438,107.215646 C813.854472,178.752402 795.879181,329.22168 647.0579,363.601168 C498.236619,397.980655 275.037156,332.504116 282.16666,256.978093 Z",
  id: "Background-Shape",
  fill: "#F4F6F8"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "783px",
    height: "373px",
    viewBox: "0 0 783 373",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/graphics.17a7c7a5.svg";
export { SvgComponent as ReactComponent };